'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function CountryComponent($http, AppConstants) {
	'ngInject';

	var service = {
		fetchCountries: fetchCountries,
		fetchCountry: fetchCountry,
		getCountries: getCountries,
		getCountry: getCountry,
		clearCountries: clearCountries
	};

	var countries = [];
	var country = {};

	return service;

	function fetchCountries() {
		var value = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

		return $http.get(AppConstants.apiUrl + '/countries', {
			'params': {
				'page': 1,
				'per_page': AppConstants.perPage,
				'query': value
			},
			'ignoreLoadingBar': true
		}).then(setCountries)['catch'](failedRequest);
	}

	function fetchCountry(id) {
		return $http.get(AppConstants.apiUrl + '/countries/' + id).then(setCountry)['catch'](failedRequest);
	}

	function setCountries(response) {
		countries = response.data.data;
		return countries;
	}

	function setCountry(response) {
		country = response.data.data;
		return country;
	}

	function getCountries() {
		return countries;
	}

	function getCountry() {
		return country;
	}

	function clearCountries() {
		countries = [];
		return countries;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}

exports['default'] = CountryComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/country/country.service.js
 **/